import React, { Fragment, useContext, useState, useEffect, useLocation } from 'react';
import { Container, Row, Col, Card, CardBody, Nav, NavItem, Form, NavLink, TabContent, TabPane, Input } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Breadcrumbs, Image, P, H4, H5, H6, Btn, DRTScrumbs } from '../../../AbstractElements';
import page_icon from '../../../assets/images/drts_home/make_payment_ico.png';
import payment_success_image from '../../../assets/images/drts_home/payment_success_ico.png';
import payment_failed_image from '../../../assets/images/drts_home/payment_failed_ico.png';
import { drtsAPIURL } from '../../../Constant';
import { trackPromise } from 'react-promise-tracker';
import { ToastContainer, toast } from "react-toastify";
import { eServiceData } from './eServiceData';




const EServicePaymentConfirmation = () => {


          const PaymentStatus = window.location.pathname.split('/').pop();  
          const [thisEserviceDetails, setThisEserviceDetails] = useState(null);
          const  thisRequestData=JSON.parse(localStorage.getItem('validatedVehicleDetails')); 
          const [paymentMessage, setPaymentMessage] = useState(null);  
          const [paymentStatusSplit, setPaymentStatusSplit] = useState(null);
          

  useEffect(() => {

    let thisEservice ='';
    if(thisRequestData!=null&&thisRequestData.eservice_code!=undefined){
      thisEservice =eServiceData.filter(eService => eService.code === thisRequestData.eservice_code);
      setThisEserviceDetails(thisEservice);
    }
    else{

    }
    let statusMessage=PaymentStatus.split('.'); //alert(JSON.stringify(statusMessage));

    if(statusMessage[0]!=null) setPaymentStatusSplit(statusMessage[0]);

    if ( statusMessage[0]!=null && statusMessage[0]=='Paid') {
      
          toast.success("Payment Processed Successfully...");

          if(statusMessage[1]!=null && statusMessage[1]=='Booking') {setPaymentMessage('Booking processed successfully!');}
          else if(statusMessage[1]!=null && statusMessage[1]=='Renewal') {setPaymentMessage('Renewal processed successfully!');}
          else if(statusMessage[1]!=null && statusMessage[1]=='Duplicate') {setPaymentMessage('Duplicate processed successfully!');}
          else if(statusMessage[1]!=null && statusMessage[1]=='NewApplication') {setPaymentMessage('Application processed successfully!');}
          else  {setPaymentMessage(' eServcie processed successfully.');}

          }
     else{

      let drtsErrMsg='';

      if(statusMessage[2]!=null){
        drtsErrMsg=statusMessage[2];
      }
     

         toast.error("Payment Failed. Try again. "+drtsErrMsg);

         if(statusMessage[1]!=null && statusMessage[1]=='Booking') {setPaymentMessage('Booking not processed! '+drtsErrMsg);}
         else if(statusMessage[1]!=null && statusMessage[1]=='Renewal') {setPaymentMessage('Renewal not processed! '+drtsErrMsg);}
         else if(statusMessage[1]!=null && statusMessage[1]=='Duplicate') {setPaymentMessage('Duplicate not processed! '+drtsErrMsg);}
         else if(statusMessage[1]!=null && statusMessage[1]=='NewApplication') {setPaymentMessage('Application not processed! '+drtsErrMsg);}
         else  {setPaymentMessage('Payment Failed! eServcie not processed. '+drtsErrMsg);}
     
       }

   }, []);
  

  return (
    <Fragment>
      <Breadcrumbs />
      <Container fluid={true}>

      <Row className="project-card" style={{width:"100%",textAlign:"center", padding:10, borderRadius: "0.7rem", margin:10}}>
          <Col md="12" className="project-list" style={{width:"100%",textAlign:"center", margin:0, padding:0, borderRadius: "0.7rem", backgroundColor:"#ffffff"}}>            
           
             <Row style={{textAlign:"center", padding:0, width:"100%", margin:0}}>
            
          <Col md='1' style={{textAlign:"center", width:"5%", backgroundColor:"#ffffff",padding:0, borderRadius: "0.7rem", margin:0}}>{" "}
          </Col>
          <Col md='10' style={{textAlign:"center", width:"90%", backgroundColor:"#ffffff", padding:0, borderRadius: "0.7rem", margin:0}}>			 
           
               {thisEserviceDetails!=null && <DRTScrumbs parent="Home" title="eService" mainTitle={thisEserviceDetails[0].title.toUpperCase()} /> }          
          </Col>

          <Col md='1' style={{textAlign:"center", width:"5%", backgroundColor:"#ffffff", padding:0, borderRadius: "0.7rem",margin:0}}>{" "} 
          </Col>

          </Row>    

          </Col>
        </Row>
  
		
		 <Row className="project-card">
          <Col md="12" className="project-list">
            <Card>
              <Row style={{width:"100%"}}>
                <Col md="3" style={{ width:"20%", textAlign:"center" , overflow: 'hidden', borderRadius:"1rem"}}>
                
                 <Image attrImage={{ src: `${page_icon}`, 
                 alt: 'Welcome to DRTS Web Portal', width:180, 
                 border: '1px solid white', borderRadius:"1rem", textAlign: "center", margin:0, overflow: 'hidden' }} />
                           
                </Col>
				
				        <Col md="9" style={{width:"80%", backgroundColor:"#ffffff"}}>



        <Row>
          <Col md="12">
            <Card>
              
              <CardBody>

        <Row className='header-wrapper m-0'>   
          <Nav tabs className="border-tab">  

          {paymentStatusSplit=='Paid' && <span>
    
             <Row style={{width:"100%"}}>
             <Col md="6" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', paddingLeft:140,width:"100%", textAlign:"center" , overflow: 'hidden', borderRadius:"1rem"}}>
              <NavItem><NavLink className={'active'} ><H5><span style={{color:'green'}}>{paymentMessage!=null && paymentMessage}</span></H5></NavLink></NavItem>                   
             </Col>
             </Row> 
             <Row style={{width:"100%"}}>
                <Col md="6" style={{ display: 'flex', alignItems: 'center', paddingLeft:180, width:"100%", textAlign:"center" , overflow: 'hidden', borderRadius:"1rem"}}>
                <Link to={`${process.env.PUBLIC_URL}/eservices/home`} alt="Access DRTS eServices">
                 <Image attrImage={{ src: `${payment_success_image}`, 
                 alt: 'Welcome to DRTS Web Portal', width:300, 
                 border: '1px solid white', borderRadius:"1rem", textAlign: "center", margin:0 }} />
                 </Link>
                           
                </Col>
              </Row>
              <Row style={{width:"100%"}}>
             <Col md="12" style={{ display: 'flex', alignItems: 'center', paddingLeft:300, width:"100%", textAlign:"center" , overflow: 'hidden', borderRadius:"1rem"}}>
               <Link to={`${process.env.PUBLIC_URL}/eservices/home`} alt="Access DRTS eServices">
                {"Go To Home"}</Link>
                </Col>
              </Row>
              </span>}

              {paymentStatusSplit=='UnPaid' && <span><Row style={{width:"100%"}}>
              <Col md="6" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', paddingLeft:140,width:"100%", textAlign:"center" , overflow: 'hidden', borderRadius:"1rem"}}>
              
              <NavItem><NavLink className={'active'} ><H5><span style={{color:'red'}}>{paymentMessage!=null && paymentMessage}</span></H5></NavLink></NavItem>   
                                  
             </Col>
          </Row>

             <Row style={{width:"100%"}}>
             <Col md="6" style={{ display: 'flex', alignItems: 'center', paddingLeft:180, width:"100%", textAlign:"center" , overflow: 'hidden', borderRadius:"1rem"}}>
                <Link to={`${process.env.PUBLIC_URL}/eservices/home`} alt="Access DRTS eServices">
                 <Image attrImage={{ src: `${payment_failed_image}`, 
                 alt: 'Welcome to DRTS Web Portal', width:300, 
                 border: '1px solid white', borderRadius:"1rem", textAlign: "center", margin:0, overflow: 'hidden' }} />
                 </Link>
                           
                </Col>
              </Row>
            <Row style={{width:"100%"}}>
             <Col md="12" style={{ display: 'flex', alignItems: 'center', paddingLeft:300, width:"100%", textAlign:"center" , overflow: 'hidden', borderRadius:"1rem"}}>
               <Link to={`${process.env.PUBLIC_URL}/eservices/PaymentEServices`} alt="Access DRTS eServices">
                {"Try Again"}</Link>
                </Col>
              </Row>
              </span>}
           
         </Nav>
        </Row>
             
              </CardBody>
            </Card>
          </Col>
        </Row>
                      
                  

                </Col>
               
              </Row>
            </Card> 
          </Col>
                  
        </Row>
		
		
		
		
		
		
      </Container>
    </Fragment>
  );
};

export default EServicePaymentConfirmation;